import script from "./AlarmLogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlarmLogs.vue?vue&type=script&setup=true&lang=ts"

import "./AlarmLogs.vue?vue&type=style&index=0&id=2947f229&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2947f229"]])

export default __exports__